export const TEXT_ALIGN_STYLE = {
  start: 'text-start pl-2',
  center: 'text-center',
}
